import React from 'react';
import {Routes,Route,Navigate} from 'react-router-dom';
import {HelmetProvider,Helmet} from 'react-helmet-async';
import HomePage from './pages/HomePage';
import ControlLandingPage from './pages/ControlLandingPage';
import CohortLandingPage from './pages/CohortLandingPage';
import JSLandingPage from './pages/JSLandingPage';
import DirectLandingPage from './pages/DirectLandingPage';
import PunchyLandingPage from './pages/PunchyLandingPage';
import NileshSpecialOfferPage from './pages/NileshSpecialOfferPage';
import AWXLandingPage from './pages/AWXLandingPage';
import FreeModuleLandingPage from './pages/FreeModuleLandingPage';
import './App.css';

function App() {
return ( 
<HelmetProvider> 
<Helmet> 
<title>ItsKaivalya - AI Development Courses</title> 
<meta name="description" content="Learn to build AI-powered applications with hands-on guidance. From concept to deployment,master full-stack AI development." /> 
<link rel="canonical" href="https://lp.itskaivalya.com/" /> 
<meta property="og:title" content="ItsKaivalya - AI Development Courses" /> 
<meta property="og:description" content="Learn to build AI-powered applications with hands-on guidance. From concept to deployment,master full-stack AI development." /> 
<meta property="og:url" content="https://lp.itskaivalya.com/" /> 
<meta property="og:type" content="website" /> 
<meta name="twitter:card" content="summary_large_image" /> 
<meta name="twitter:title" content="ItsKaivalya - AI Development Courses" /> 
<meta name="twitter:description" content="Learn to build AI-powered applications with hands-on guidance. From concept to deployment,master full-stack AI development." /> 
</Helmet> 
<Routes> 
{/* Main Routes */} 
<Route path="/" element={<HomePage />} /> 
<Route path="/develop-apps-with-ai-control-416" element={<ControlLandingPage />} /> 
<Route path="/develop-apps-with-ai-cohort-416" element={<CohortLandingPage />} /> 
<Route path="/develop-apps-with-ai-js-416" element={<JSLandingPage />} /> 
<Route path="/develop-apps-with-ai-direct-416" element={<DirectLandingPage />} /> 
<Route path="/develop-apps-with-ai-punchy-416" element={<PunchyLandingPage />} /> 
<Route path="/nilesh-ji-special-offer" element={<NileshSpecialOfferPage />} /> 
<Route path="/develop-apps-with-ai-awx" element={<AWXLandingPage />} /> 
<Route path="/build-apps-with-ai-free-module-access" element={<FreeModuleLandingPage />} /> 

{/* Legacy hash redirects */} 
<Route path="/#/develop-apps-with-ai-control-416" element={<Navigate to="/develop-apps-with-ai-control-416" replace />} /> 
<Route path="/#/develop-apps-with-ai-cohort-416" element={<Navigate to="/develop-apps-with-ai-cohort-416" replace />} /> 
<Route path="/#/develop-apps-with-ai-js-416" element={<Navigate to="/develop-apps-with-ai-js-416" replace />} /> 
<Route path="/#/develop-apps-with-ai-direct-416" element={<Navigate to="/develop-apps-with-ai-direct-416" replace />} /> 
<Route path="/#/develop-apps-with-ai-punchy-416" element={<Navigate to="/develop-apps-with-ai-punchy-416" replace />} /> 
<Route path="/#/nilesh-ji-special-offer" element={<Navigate to="/nilesh-ji-special-offer" replace />} /> 
<Route path="/#/develop-apps-with-ai-awx" element={<Navigate to="/develop-apps-with-ai-awx" replace />} /> 
<Route path="/#/build-apps-with-ai-free-module-access" element={<Navigate to="/build-apps-with-ai-free-module-access" replace />} /> 

{/* Fallback */} 
<Route path="*" element={<Navigate to="/" replace />} /> 
</Routes> 
</HelmetProvider> 
);}

export default App;